<template>
  <!-- 文件 -->
  <div v-if="file.Materials">
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ file.Name }}</p>
    </div>
    <div class="bottom_content">
      <ul v-if="file.Materials.length > 0">
        <li
          v-for="d in file.Materials"
          :key="d.DeliveryId"
          @click="handelReadFile(d)"
        >
          <div class="bottom_content_list">
            <div class="icon_box">
              {{ getIcon(d) }}
            </div>
            <p v-if="d" style="word-wrap: break-word">
              {{ d.MaterialName }}
            </p>
          </div>
          <div>
            <img
              alt=""
              class="arrowIcon"
              src="../../../assets/images/arrowright.svg"
            />
          </div>
        </li>
      </ul>
      <van-empty v-else description="暂无课程文件" image-size="40" />
    </div>
    <ReadFile ref="ReadFile" />
  </div>
</template>

<script>
  import api from '@/api'
  import store from '@/store'
  import { Dialog, Toast } from 'vant'
  import { onMounted, ref, watch } from 'vue'
  import { copyText } from '@/utils/index'
  import ReadFile from '@/components/ReadFile'
  export default {
    components: {
      ReadFile,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      file: {
        type: Object,
      },
    },

    setup(props) {
      const ReadFile = ref(null)
      const videoArr = ref([])
      // const downloadFile = async (data) => {
      //   let url = data.MaterialUrl
      //   const MaterialType = data.MaterialType
      //   if (MaterialType === 10 || MaterialType === 20) {
      //     if (!data.asset) {
      //       const asset = await getVod(data.AssetId)
      //       data.asset = asset
      //     }
      //     url = data.asset.BaseInfo.VideoUrl
      //   }
      //   // const u = navigator.userAgent
      //   // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
      //   // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      //   if (MaterialType === 10 || MaterialType === 20) {
      //     //location.href = url
      //     setTimeout(() => {
      //       window.open(url)
      //     }, 100)
      //   } else if (MaterialType === 30) {
      //     window.open(api.FileHost + url)
      //   } else {
      //     Dialog.alert({
      //       title: '请复制链接至浏览器下载',
      //       message: api.FileHost + url,
      //       confirmButtonText: '复制',
      //     }).then(() => {
      //       copyText(api.FileHost + url)
      //     })
      //   }
      // }
      // 获取vod detail
      const getVod = async (id) => {
        const loading = Toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true,
        })
        return new Promise((resolve, reject) => {
          store
            .dispatch('service/ShowAssetDetail', {
              AssetId: id,
            })
            .then((data) => {
              resolve(data.Data)
              loading.clear()
            })
            .catch((e) => {
              reject(e)
              loading.clear()
            })
        })
      }
      const getIcon = (item) => {
        let MaterialUrl = ''
        if (item.MaterialType === 10 || item.MaterialType === 20) {
          MaterialUrl = item.MaterialName
        } else {
          MaterialUrl = item.MaterialUrl
        }
        const len = MaterialUrl.split('.').length
        let icon = 'file'
        if (len > 1) {
          icon = MaterialUrl.split('.')[len - 1]
        }
        return icon
      }

      const handelReadFile = (item) => {
        ReadFile.value.readFile(item)
      }

      return {
        videoArr,
        //downloadFile,
        copyText,
        Dialog,
        getIcon,
        ReadFile,
        handelReadFile,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    min-height: 70px;
    ul {
      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #e4e5ea;
        padding-top: 16px;
        .arrowIcon {
          width: 24px;
        }
        .bottom_content_list {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 90%;
          .icon_box {
            background-color: #454976;
            width: 28px;
            height: 28px;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            font-size: 12px;
            color: #fff;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 28px;
            height: 28px;
          }
          p {
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            margin-left: 14px;
            width: 86%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
</style>
